module.exports = __webpack_public_path__ + "static/media/DZW_05.d47eda57.jpg";